/**
 * Centralized naming constants for Dashboard feature.
 * All display names and default values must be imported from here.
 * NO inline string literals allowed in business logic or UI components.
 */

/** Base name for new dashboards: "My Dashboard", "My Dashboard (2)", etc. */
export const DASHBOARD_DEFAULT_BASE_NAME = 'My Dashboard';
/** Label for the "New Dashboard" section in menus */
export const DASHBOARD_NEW_SECTION_LABEL = 'New Dashboard';
/** Base name for new tabs/pages: "New Page", "New Page (2)", etc. */
export const TAB_DEFAULT_BASE_NAME = 'New Page';
